import { TagText } from '@calendly/tags';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { FullStoryExclude, FullStoryMask } from '../../../../shared/fullstory_privacy';
import { DELIMITER_CHARS } from '../constants';
const emailInputCss = "e11zdjcg";
const EmailInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(emailInputCss, props.className)} />;
});
export const EditView = ({
  name,
  onChange,
  toggleView
}) => {
  const handleInput = useCallback(({
    target: {
      value
    }
  }) => {
    if (!value) toggleView();
    onChange(value);
  }, [onChange, toggleView]);
  const handleFocus = useCallback(({
    target
  }) => {
    target.select();
  }, []);
  const handleBlur = useCallback(({
    target: {
      value
    }
  }) => {
    toggleView();
    onChange(value);
  }, [onChange, toggleView]);
  const handleBeforeInput = useCallback(event => {
    if (DELIMITER_CHARS.indexOf(event.data) > -1) {
      event.preventDefault();
      toggleView();
    }
  }, [toggleView]);
  const handleMouseDown = useCallback(event => {
    // avoid processing mouseDown on the outer TagContainer
    // which would otherwise focus TagInput
    event.stopPropagation();
  }, []);
  return <>
      <TagText><FullStoryMask>{name}</FullStoryMask></TagText>
      <FullStoryExclude>
        <EmailInput autoFocus type="email" spellCheck={false} onChange={() => {}} onBlur={handleBlur} onMouseDown={handleMouseDown} onFocus={handleFocus} onInput={handleInput} onBeforeInput={handleBeforeInput} value={name} />
      </FullStoryExclude>
    </>;
};

require("./edit_view.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./edit_view.js");